import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { call, put, select } from 'redux-saga/effects'
import {
  resetPatientVitalsState,
  setAssessedBy,
  setComments,
  setDate,
  setTime,
} from '../../vitals/store/vitals.actions'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getVitalOptionsSelector } from '../../options/selectors'
import { IOption } from '../../../common/common.types'
import { getUserIdSelector } from '../../user/selectors'
import { IVitalOptionsState } from '../../options/store/options.types'
import { savePatientVitals } from '../../vitals/saga/savePatientVitals.saga'

export function* setVitalQuickAction() {
  const userId = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)

  const { selectedQuickActionButton } = quickActionsObject
  const { props, comments } = selectedQuickActionButton

  const { savedTimeString, currentDate } = props
  const vitalOptions: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const { assessedByOptions } = vitalOptions

  const assessedBy: IOption | undefined = assessedByOptions.find((option: IOption) => option.id === +userId)
  yield call(delay, 100)
  yield put(setTime(savedTimeString))
  yield put(setDate(currentDate))
  yield put(setComments(comments))
  yield put(setAssessedBy(assessedBy ? assessedBy : null))
  yield call(savePatientVitals)
  yield put(resetPatientVitalsState())
}

export const delay = (time: number) => new Promise((resolve) => setTimeout(resolve, time))
export function* setVitalQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_VITAL_BUTTON_TYPE], setVitalQuickAction)
}
